import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

const SrHouseholdBuyersAgentRow = ({
  className,
  buyersAgentName,
  buyersAgentPhone,
  buyersAgentEmail,
}) => (
  <div className={classnames('SrHouseholdBuyersAgentRow', className)}>
    <div className='icon' />
    <span>
      {
        `${buyersAgentName || 'Unknown'}: `
        + `${buyersAgentPhone || ''} `
        + `${buyersAgentEmail || ''}`
      }
    </span>
  </div>
);

SrHouseholdBuyersAgentRow.propTypes = {
  className: PropTypes.string,
  buyersAgentName: PropTypes.string.isRequired,
  buyersAgentPhone: PropTypes.string.isRequired,
  buyersAgentEmail: PropTypes.string.isRequired,
};

SrHouseholdBuyersAgentRow.displayName = 'SrHouseholdBuyersAgentRow';

export default SrHouseholdBuyersAgentRow;
